import { slugify } from '@/utils/slugify';
import { Heading, chakra, VisuallyHidden, As } from '@chakra-ui/react';

interface ArticleHeadingProps {
  children: string;
  as?: As;
}

export const ArticleHeading = ({ as, children }: ArticleHeadingProps) => {
  const id = slugify(children);

  return (
    <Heading
      data-group
      id={id}
      as={as}
      size="md"
      mt={{ base: 'xl', lg: '5xl' }}
      mr="lg"
      scrollMarginTop={'3rem'}
      _hover={{
        a: {
          display: 'inline-block',
        },
      }}
    >
      {children}
      <chakra.a aria-label="anchor" href={`#${id}`} color="muted" pl="xs" display="none">
        #<VisuallyHidden>Copy URL to this article section</VisuallyHidden>
      </chakra.a>
    </Heading>
  );
};
